<template>
  <v-container fluid class="mt-0 pt-0 mb-0 pb-0">
    <v-progress-linear
      v-if='$vars.loading'
      indeterminate
      class='primary--text loader'
    ></v-progress-linear>
    <v-toolbar dense flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model='search'
          append-icon='search'
          label='Suchen'
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
    </v-toolbar>
    <v-divider></v-divider>

<!-- ***************************************************************** 

Tabelle mit Bundesbrüdern

***************************************************************** -->
    <v-row class="ma-0 pa-0">
      <v-col cols="12">
        <v-card outlined>
          <v-data-table
            dense
            :height="sideHeight"
            :headers="headers"
            :items="bbrbbr"
            :search="search"
            fixed-header
            hide-default-footer
            :hide-default-header="$vuetify.breakpoint.xsOnly"
            :items-per-page="-1"
            no-data-text="Keine Kontakte vorhanden"
          >
          <template v-slot:header="{ item }">
            <thead>
              <tr class="hidden-sm-and-up">
                <th>Nachname</th>
                <th>Vorname</th>
              </tr>
            </thead>
          </template>
          <template v-slot:item="{ item }">
            <tr v-on:dblclick="(bbr = item) && (showKontakt = true)">
              <td width="30px"><v-icon>{{ item.bildAhnengalerie ? 'check' : 'close' }}</v-icon></td>
              <td width="30px"><v-avatar color="grey" size="28">
                <v-img class="ma-4 profilbild" :src="item.bildAhnengalerie200 ? item.bildAhnengalerie200 : item.bildAhnengalerie" v-if="item.bildAhnengalerie"></v-img>
                <v-icon dark small v-else>person</v-icon>
              </v-avatar></td>
              <td width="30px"><v-icon>{{ item.bildAhnengalerie500 ? 'check' : 'close' }}</v-icon></td>
              <td v-for="header in headers" :key="header.number" v-if="header.type !== 'fix'">{{ item[header.value] }}</td>
            </tr>
          </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

<!-- ***************************************************************** 

Dialog einzelner Bundesbruder

***************************************************************** -->

  <dialogKontakt :visible.sync="showKontakt" :bbr="bbr" @close="showKontakt = false"></dialogKontakt>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        sideNav: false,
        singleSelect: false,
        selected: [],
        expanded: [],
        bbr: {},
        showKontakt: false,
        menu: '',
        date: '',
        headers: [
          { number: '0', text: '0', align: 'left', value: 'bild', type: 'fix' },
          { number: '1', text: '200', align: 'left', value: 'bild200', type: 'fix' },
          { number: '2', text: '500', align: 'left', value: 'bild500', type: 'fix' },
          { number: '3', text: 'Nummer', align: 'left', value: 'rbonummer' },
          { number: '4', text: 'Nachname', align: 'left', value: 'nachname' },
          { number: '5', text: 'Vorname', align: 'left', value: 'vorname' }
        ],
        sortBy: 'Nachname'
      }
    },
    computed: {
      bbrbbr () { return this.$store.getters['bbrbbr/nurBbrbbr'] },
      sideHeight () {
        if (this.$store.state.user.user !== null && this.$store.state.user.user !== undefined) {
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 'calc(100vh - 191px)'
            case 'sm': return 'calc(100vh - 169px)'
            case 'md': return 'calc(100vh - 199px)'
            case 'lg': return 'calc(100vh - 191px)'
            case 'xl': return 'calc(100vh - 191px)'
          }
        } else {
          switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 'calc(100vh - 189px)'
            case 'sm': return 'calc(100vh - 189px)'
            case 'md': return 'calc(100vh - 189px)'
            case 'lg': return 'calc(100vh - 189px)'
            case 'xl': return 'calc(100vh - 189px)'
          }
        }
      }
    }
  }
</script>

<style>
.profilbild .v-image__image--cover {
  background-position: top !important;
}
</style>



// WEBPACK FOOTER //
// ahnengalerie.vue?1e853866